import { createFileRoute } from '@tanstack/react-router';

import { ShareLinkProposalReviewPage } from '../features/sharing/share-link-proposal-review-page';

export const Route = createFileRoute(
  '/manage/$companySlug/share-link-change-proposals/$presentationId/$proposalId',
)({ component: RouteComponent });

function RouteComponent() {
  const { companySlug, presentationId, proposalId } = Route.useParams();
  return (
    <ShareLinkProposalReviewPage
      companySlug={companySlug}
      presentationId={presentationId}
      proposalId={proposalId}
    />
  );
}
